'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  root: {
    margin: '8px 0',
    width: '100%',
    display: 'flex',
    justifyContent: 'center'
  },
  text: {
    fontWeight: 'inherit',
    color: _colors2.default.white,
    fontSize: '16px',
    padding: '4px 8px',
    fontFamily: 'inherit',
    margin: 0,
    backgroundColor: 'rgba(117, 127, 133, 0.4)',
    backdropFilter: 'blur(10px)',
    borderRadius: '4px'
  }
};

exports.default = styles;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/anchor-ui/date-separator/styles.js
// module id = 823
// module chunks = 0